import React from 'react';
import NavMenu from '../Nav/NavMenu';
import Footer from '../footer/Footer';
import EmptySlider from '../sliders/EmptySlider';
import FlightImage from "../../assets/static/support.png";
import { Container, Row, Col, Button } from 'react-bootstrap';
import onlineBankingImage from "../../assets/static/business/business_banking.webp"; 

function BusinessOnlineBanking() {
  return (
    <div>
      <NavMenu></NavMenu>
      <br></br><br></br>
      <EmptySlider 
        title="Business Online Banking? We’ve got you covered." 
        description="Kontriman offers various ways to support your Business Online Banking – through our help center, chat support, and email. Get the assistance you need, anytime and anywhere." 
        imageUrl={FlightImage}
    />
    <div>
      <Container fluid className="my-5 bg-custom">
        <Container className='container-padding'>
          <Row className="flex-column flex-md-row">
            {/* Image column */}
            <Col md={6} className="order-2 order-md-1">
              <img
                src={onlineBankingImage}
                alt="Business Online Banking"
                className="img-fluid"
                style={{ maxWidth: '80%' }}
              />
            </Col>

            {/* Text column */}
            <Col md={6} className="d-flex align-items-center order-1 order-md-2">
              <div>
                <h1 className='custom_heading'>Business Online Banking</h1>
                <p>
                  Manage your business finances anytime, anywhere with Kontriman’s Business Online Banking platform. Our secure and user-friendly digital banking services empower you to handle transactions, payments, and account management with ease.
                </p>
                <p>
                  Enjoy real-time account access, seamless fund transfers, and customized alerts to keep your business operations smooth and efficient. Experience the convenience of banking on your terms, backed by Kontriman’s trusted support.
                </p>
                <p><strong>Features include:</strong></p>
                <ul>
                  <li>24/7 secure access to your business accounts</li>
                  <li>Instant fund transfers and payments</li>
                  <li>Real-time transaction alerts and notifications</li>
                  <li>Multi-user access with customizable permissions</li>
                  <li>Dedicated online banking support team</li>
                </ul>

                <a href="/business-online-banking-signup">
                  <Button className='custom-button mt-3'>Get Started</Button>
                </a>
              </div>
            </Col>
          </Row>
        </Container>
      </Container>
    </div>

      <Footer></Footer>
    </div>
  );
}

export default BusinessOnlineBanking;
